import axios, { AxiosRequestConfig } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { clearSessionCredentials } from '../globalFunctions';
import { AcademicUser } from '../types';

export class UserDAO {
    static async save(token: string, navigate: NavigateFunction, user: AcademicUser) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/user/${user.id}`,
                user,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: 'Erro ao salvar usuário',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }

    static async restore(token: string, navigate: NavigateFunction, id: number) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/user/${id}/restore`,
                {},
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: 'Erro ao restaurar usuário',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }

    static async delete(token: string, navigate: NavigateFunction, id: number) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/user/${id}`,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: 'Erro ao desativar usuário',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }
}
